import { render, staticRenderFns } from "./NoPlannedCall.vue?vue&type=template&id=6beba49b&lang=pug"
import script from "./NoPlannedCall.vue?vue&type=script&lang=js"
export * from "./NoPlannedCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports